








import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "../../api/ApiFactory";
import { CountyDto } from "@/api/ClientPortalApiClient";

@Component({})
export default class CbxCounty extends Vue {
  private types: CountyDto[] | null = [];
  public selectedType = new CountyDto();

  public created() {
    this.getAvailableTypes();
  }

  public setSelected(type: CountyDto | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  public typeSelected(type: CountyDto) {
    this.$emit("countySelected", type);
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .county_IndexAll()
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }
}
